export function getFileExtension(path?: string | null): string | undefined {
  if (!path) {
    return undefined;
  }

  const [cleanPath] = path.split("?");
  const segments = cleanPath.split(".");
  if (segments.length <= 1) {
    return undefined;
  }

  const extension = segments.pop()?.toLowerCase();
  return extension || undefined;
}

function sanitizeLabel(label: string): string {
  return label.replace(/\s/g, "_");
}

export function buildDownloadFilename(
  projectName: string,
  label: string,
  path: string
): string {
  const sanitizedProjectName = projectName.replace(/\s/g, "");
  const sanitizedLabel = sanitizeLabel(label);
  const extension = getFileExtension(path);
  const ext = extension ? `.${extension}` : "";
  return `${sanitizedProjectName}_${sanitizedLabel}${ext}`;
}
